﻿import { LiveDataSetStation, Status } from "../../API/LiveData/LiveDataSet";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "../../Formatters/IStationValueFormatter";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { PopupChartable } from "../../PopupChartable";

export class StationPopupTableCell extends PopupChartable {

    constructor(public mainSite: MainSite, container: JQuery, valueFormatter: IStationValueFormatter, liveDataStation: LiveDataSetStation, warningRules: WarningGroup, openPopups: string[]) {

        super(mainSite);

        this.station = liveDataStation.Station;
        this.valueFormatter = valueFormatter;
        var valueObject: IStationValueObject = valueFormatter.format(liveDataStation, warningRules);

        var cell = $('<td></td>')
            .appendTo(container)
            .attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.')
            .click((e: JQueryMouseEventObject) => {
            this.renderPopup(e, openPopups);
            });

        cell.append($('<div class="midi_mapPage_popup_table_group_name"></div>').append(valueFormatter.getShortName()));

        

        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);

        cell.append($('<div class="midi_mapPage_popup_table_group_value"></div>').append(valueObject.Value));

        if (valueObject.Status === null || valueObject.Status === Status.Expired) {
            cell.css('font-size', '0.8em');
            return;
        }

        if (valueObject.Status !== Status.Good) {
            cell.addClass('midi_siteObsPage_expiring');
        }

        if (valueObject.WarningThreshold == WarningThreshold.Level3) {
            cell.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
            cell.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level1) {
            cell.addClass('midi_siteObsPage_exceeded_threshold_1');
        }

        var unitsString = '';
        if (valueFormatter.getUnits()) {
            unitsString = valueFormatter.getUnits();
        }
        if (valueObject.ParameterDefinition && valueObject.ParameterDefinition.Suffix) {
            var suffixString = valueObject.ParameterDefinition.Suffix;
            if (unitsString != '') {
                suffixString += ', ';
            }
            unitsString = suffixString + unitsString;
        }

        cell.append($('<div class="midi_mapPage_popup_table_group_units"></div>').append(unitsString));

    }
}